import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { PopupBaseComponent } from '../../../../shared/components/popup/popup-base/popup-base.component';
import { ButtonComponent, ButtonType } from '../../../../shared/components/button/button.component';
import { TermsOfServiceContentComponent } from '../../../../shared/components/terms-of-service-content/terms-of-service-content.component';
import { ViewTermsPopupModel } from './view-terms-popup.model';
import { LayoutStore, LayoutStoreType } from '../../../../core/store/layout.store';

@Component({
    selector: 'juyo-view-terms-popup',
    styleUrl: './view-terms-popup.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PopupBaseComponent, ButtonComponent, TermsOfServiceContentComponent],
    template: `
        <juyo-popup-base [popupId]="model().id" [showHeader]="true">
            <span slot="header">Terms of Service</span>

            <div slot="body" class="tos-scroll">
                <juyo-terms-of-service-content />
            </div>

            <ng-container slot="footer">
                <juyo-button [buttonType]="ButtonType.PURPLE" (clicked)="onClose()">Close</juyo-button>
            </ng-container>
        </juyo-popup-base>
    `,
})
export class ViewTermsPopupComponent {
    public model = input.required<ViewTermsPopupModel>();

    protected readonly ButtonType = ButtonType;

    private layoutStore: LayoutStoreType = inject(LayoutStore);

    protected onClose(): void {
        this.layoutStore.closePopup(this.model().id);
    }
}
